import FallbackLoader from '../../../../loaders/components/FallbackLoader';

export default FallbackLoader(
  () => import(/* webpackChunkName: "async-SaveAddressDialog" */'./modal'),
  { fallback: null },
);
